import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { FormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { RouterModule, Routes } from '@angular/router';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { ScheduleService } from './services/schedule.service';
import { ScheduleOdooService } from './services/schedule-odoo.service';
import { ScheduleInMemoryService } from './services/schedule-in-memory.service';
import { ScheduleStateService } from './services/schedule-state.service';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { PageSchedulesComponent } from './page-schedules/page-schedules.component';

const routes: Routes = [{
  path: 'schedule',
  component: PageSchedulesComponent,
}];

const scheduleServiceClass = environment.production ? ScheduleOdooService : ScheduleInMemoryService;

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    GeneralModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    ScheduleComponent,
    ScheduleListComponent,
    PageSchedulesComponent,
  ],
  exports: [
  ],
  providers: [
    ScheduleStateService,
    { provide: ScheduleService, useClass: scheduleServiceClass },
  ]
})
export class ScheduleModule { }
